import React, { useContext } from "react";
import { Lock } from "lucide-react";
import SubModal from "./SubModal";
import { PostAPI } from "../../../ApiServices/ApiServices";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../Context/AppContext";
const AccountRestrictedModal = ({
  show,
  onRenewNow,
  onContactSupport,
}) => {
  const navigate = useNavigate();
const { user, setUser } = useContext(AppContext);
const handleLogout = async () => {
  try {
    await PostAPI(
      {
        url: "/auth/doctor/logout",
        data: {},
      },
      (res) => {
        console.log("Logout response:", res);
      }
    );
  } catch (error) {
    console.error("Logout failed:", error);
  } finally {
    // Reset app state
    setUser({ type: "logout" });

    // Clear session/local storage
    sessionStorage.removeItem("loggedIn");
    sessionStorage.removeItem("subscribed");
    localStorage.removeItem("token");
    localStorage.removeItem("doctorData");

    // Navigate to login
    navigate("/");
  }
};

  return (
    <SubModal show={show}>
      <div className="sub-icon-wrap danger">
        <Lock size={26} />
      </div>

      <h3 className="sub-modal-title">Account Restricted</h3>

      <p className="sub-modal-text sub-modal-text-strong">
        Your Clinic Plan has expired.
      </p>

      <p className="sub-modal-text">
        Renew your subscription to continue using DigiDoc.
      </p>

      <div className="sub-actions">
        <button
          type="button"
          className="btn bg-dg c-w w-100 fw-semibold py-2"
          onClick={onRenewNow}
        >
          Renew Now
        </button>
      </div>

      {/* Logout */}
      <div
        className="text-center text-danger text-decoration-underline mt-3"
        style={{ cursor: "pointer" }}
        onClick={handleLogout}
      >
        Logout
      </div>

      <p className="sub-footnote">
        Need help?{" "}
        <a href="mailto:support@digidoc.co.in">
          Contact Support
        </a>
      </p>
    </SubModal>
  );
};

export default AccountRestrictedModal;